exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menuButtonsMetaInfoButton{min-width:75px;flex-shrink:2;border-left:1px solid var(--grey-30)}.menuButtonsMetaInfoButtonButton{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

